import { GENDER_SELECT_OPTIONS } from '../misc/Constants'


const ENROLLMENT_STATUS_STATES = ['active', 'future', 'waitlist', 'inactive']
const SORT_STATES = ['asc', 'desc']


export const STUDENTS_COLUMNS = [
  // Note: The fixed first column is not listed here
  {
    label: 'Years in Community',
    field: 'first_activity',
  },
  {
    label: 'Enrollment Status',
    field: 'enrollment_status',
  },
  {
    label: 'Total Enrollments',
    field: 'total_enrollments',
  },
  {
    label: 'Total Revenue',
    field: 'total_revenue',
  },
  {
    label: 'Strokes Lost',
    field: 'strokes_lost',
  },
  {
    label: '9HE Rounds',
    field: 'nine_hole_rounds',
  },
  {
    label: 'Casual Rounds',
    field: 'casual_rounds',
  },
  {
    label: 'Practice Sessions',
    field: 'practice_sessions',
  },
  {
    label: 'Time Practiced',
    field: 'time_practiced',
  },
  {
    label: 'Age',
    field: 'age',
  },
  {
    label: 'Gender',
    field: 'gender',
  },
  {
    label: 'Level',
    field: 'level',
  },
]

export const DEFAULT_SORT_OPTION = { sortField: STUDENTS_COLUMNS.at(0).field, sortValue: SORT_STATES.at(0) }

export const getSortStates = (sortField) => {
  switch (sortField) {
    case 'enrollment_status':
      return ENROLLMENT_STATUS_STATES
    case 'gender':
      return GENDER_SELECT_OPTIONS.map(gender => gender.value)
    default:
      return SORT_STATES
  }
}
